"use strict";

require('../libs/jqueryNativeTrigger');

var moduleName = "spinner";

module.exports = function () {
	$("[js-spinner]").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);



		var wrap = $(this),
			entry = wrap.find('[js-spinner-entry]'),
			entryMin = entry.attr('min') || 1,
			entryMax = entry.attr('max') || 90000,
			btnMinus = wrap.find('[js-spinner-btn-minus]'),
			btnPlus = wrap.find('[js-spinner-btn-plus]');

 

		$(window).on('load change', function() {
			changeEntry()
		});

		btnMinus.on('click', function(e) {
			e.preventDefault();
			changeEntry('minus');
		});

		btnPlus.on('click', function(e) {
			e.preventDefault();
			changeEntry('plus');
		});



		function changeEntry(direction) {
			var entryVal = parseFloat(entry.val());

			// Если передан минус, то уменьшаем значение на 1
			if(direction == 'minus') {
				entry.val(--entryVal);
			}

			// Если передан плюс, то увеличиваем значение на 1
			if (direction == 'plus') {
				entry.val(++entryVal);
			}

			// Если значения меньше минимального, то ставим минимальное
			if(entryVal < entryMin) {
				entry.val(entryMin);
			}

			// Если значения больше максимального, то ставим максимальное
			if(entryVal > entryMax) {
				entry.val(entryMax);
			}

			// Если значения нет, то ставим 1
			if(isNaN(entryVal)) {
				entry.val(1);
			}

			// Если значения равно минимальному, то скрываем минус, иначе показываем
			if(entry.val() == entryMin) {
				hideBtnMinus(true);
			} else {
				hideBtnMinus(false);
			}

			// Если значения равно максимальному, то скрываем плюс, иначе показываем
			if(entry.val() == entryMax) {
				hideBtnPlus(true);
			} else {
				hideBtnPlus(false);
			}

			entry.nativeTrigger('spinchange');
		}



		function hideBtnMinus(hide) {
			if(hide) {
				btnMinus.css({'left' : '-90000px'});
			} else {
				btnMinus.css({'left' : 'auto'});
			}
		}

		function hideBtnPlus(hide) {
			if(hide) {
				btnPlus.css({'left' : '-90000px'});
			} else {
				btnPlus.css({'left' : 'auto'});
			}
		}



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/spinnerInit.js
 **/